var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 10.75C20.75 16.27 16.27 20.75 10.75 20.75C5.23 20.75 1.86 15.19 1.86 15.19M1.86 15.19H6.38M1.86 15.19V20.19M0.75 10.75C0.75 5.23 5.19 0.75 10.75 0.75C17.42 0.75 20.75 6.31 20.75 6.31M20.75 6.31V1.31M20.75 6.31H16.31",
    stroke: "#A0ACB9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDashboard);
export default __webpack_public_path__ + "static/media/refreshDashboard.dae48397d7a45b5edcda315b48e628d8.svg";
export { ForwardRef as ReactComponent };